import { touchDetectedEntity, touchEntity } from './touchEntity';
import { Dispatchable } from 'module/Redux';

export namespace MainAction {
  export const updateTouchDetected = (val: boolean): Dispatchable => touchDetectedEntity.actionCreators.set(val);
  export const updateTouch = (val: boolean): Dispatchable => touchEntity.actionCreators.set(val);
}



// WEBPACK FOOTER //
// ./src/module/Redux/Main/MainAction.ts